export const SEARCH_RESTAURANTS = "SEARCH_RESTAURANTS";
export const CLEAR_SEARCH = "CLEAR_SEARCH";
export const SET_PICKUP_DATE = "SET_PICKUP_DATE";
export const SET_PICKUP_RANGE = "SET_PICKUP_RANGE";
export const SET_GUEST_NUMBER = "SET_GUEST_NUMBER";
export const SET_ASAP="SET_ASAP";
